<section class="section-card" [class.section-card--success]="variant() === 'success'">
  @if (heading()) {
    <div class="section-card__header d-flex align-items-center justify-content-between">
      <h2 class="section-card__heading m-0">
        {{ heading() }}
        @if (headingSuffix()) {
          <span class="section-card__heading-suffix">{{ headingSuffix() }}</span>
        }
      </h2>
      <div class="section-card__actions d-flex align-items-center gap-2">
        <ng-content select="[card-actions]"></ng-content>
      </div>
    </div>
  }
  <div class="section-card__body">
    <ng-content></ng-content>
  </div>
</section>
